<template>
    <div>
        <!--上传-->
        <UploadAbstract @upload-result="generatorRes" v-if="uploadShow"></UploadAbstract>
        <!--生成-->
        <div v-else>
            <ToolRight></ToolRight>
        </div>
    </div>
</template>

<script>
import UploadAbstract from '@/components/abstract/UploadAbstract.vue';
import ToolRight from '@/components/ToolRight.vue';

export default {
    components: {
        UploadAbstract,
        ToolRight
    },
    data() {
        return {
            uploadShow: false,

        };
    },
    methods: {
        generatorRes(res) {
            console.log(res);
            this.uploadShow = false;
        }
    }
}
</script>

<style lang="scss" scoped>

</style>